import { createPointsConstants } from './create-points.constants'

const initialState = {
	isCreating: false
}

function createPointsReducer(state = initialState, { type, errors }) {
	switch (type) {
		case createPointsConstants.CREATE_POINTS:
			return {
				...state,
				isCreating: true
			}
		case createPointsConstants.POINTS_CREATED:
			return {
				...state,
				isCreating: false,
				errors
			}
		default:
			return state
	}
}

export { createPointsReducer as Reducer }
